var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveDiscountCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.9987 14.6668C11.6806 14.6668 14.6654 11.6821 14.6654 8.00016C14.6654 4.31826 11.6806 1.3335 7.9987 1.3335C4.3168 1.3335 1.33203 4.31826 1.33203 8.00016C1.33203 11.6821 4.3168 14.6668 7.9987 14.6668Z",
    fill: "#50429B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70495 8.00023L10.2383 6.4669C10.4316 6.27357 10.4316 5.95357 10.2383 5.76023C10.0449 5.5669 9.72495 5.5669 9.53162 5.76023L7.99828 7.29357L6.46495 5.76023C6.27161 5.5669 5.95161 5.5669 5.75828 5.76023C5.56495 5.95357 5.56495 6.27357 5.75828 6.4669L7.29161 8.00023L5.75828 9.53357C5.56495 9.7269 5.56495 10.0469 5.75828 10.2402C5.85828 10.3402 5.98495 10.3869 6.11161 10.3869C6.23828 10.3869 6.36495 10.3402 6.46495 10.2402L7.99828 8.7069L9.53162 10.2402C9.63162 10.3402 9.75828 10.3869 9.88495 10.3869C10.0116 10.3869 10.1383 10.3402 10.2383 10.2402C10.4316 10.0469 10.4316 9.7269 10.2383 9.53357L8.70495 8.00023Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDiscountCode);
export default __webpack_public_path__ + "static/media/remove-discount-code.389180cd1cb57bcab679db85ee87098c.svg";
export { ForwardRef as ReactComponent };